// extracted by mini-css-extract-plugin
export var highlighted = "navbar-module--highlighted--009c1";
export var mainNavigation = "navbar-module--main-navigation--67e7e";
export var mainNavigationLink = "navbar-module--main-navigation-link--9a367";
export var mainNavigationLink__active = "navbar-module--main-navigation-link__active--42b93";
export var open = "navbar-module--open--c9265";
export var stickyBar = "navbar-module--sticky-bar--30f12";
export var stickyBarContent = "navbar-module--sticky-bar-content--78c6f";
export var toggle = "navbar-module--toggle--5fa64";